import {
  useForm,
  FieldValues,
  UseFormReturn,
  DefaultValues
} from 'react-hook-form'
import { useContactForm } from '@/contexts/ContactFormContext'

const useStepForm = <T extends FieldValues>(
  stepKey: keyof ReturnType<typeof useContactForm>['formData'],
  defaultValues: DefaultValues<T>
): UseFormReturn<T> & {
  onNextStep: (data: T, handleNextStep: () => void) => void
  onPreviousStep: (data: T, handlePreviousStep: () => void) => void
} => {
  const { updateStepData } = useContactForm()

  const form = useForm<T>({
    mode: 'onChange',
    defaultValues
  })

  const onNextStep = (data: T, handleNextStep: () => void) => {
    updateStepData(stepKey as any, data)
    handleNextStep()
  }

  const onPreviousStep = (data: T, handlePreviousStep: () => void) => {
    updateStepData(stepKey as any, data)
    handlePreviousStep()
  }

  return { ...form, onNextStep, onPreviousStep }
}

export default useStepForm
